import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width", "height"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getSize } from '../operators/getSize';
import SkeletonBase from './SkeletonBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonTextWrapper = styled.div.withConfig({
  displayName: "SkeletonText__SkeletonTextWrapper",
  componentId: "wpp8gq-0"
})(["position:relative;width:", ";height:", ";max-height:24px;"], ({
  width
}) => getSize(width), ({
  height
}) => getSize(height));
const SkeletonTextInner = styled(SkeletonBase).withConfig({
  displayName: "SkeletonText__SkeletonTextInner",
  componentId: "wpp8gq-1"
})(["height:0.75em;left:0;position:absolute;top:50%;transform:translateY(-50%);width:100%;"]);
const SkeletonText = _ref => {
  let {
      width = '100%',
      height = 'auto'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(SkeletonTextWrapper, {
    width: width,
    height: height,
    children: ["\xA0", /*#__PURE__*/_jsx(SkeletonTextInner, Object.assign({}, rest))]
  });
};
SkeletonText.displayName = 'SkeletonText';
SkeletonText.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default SkeletonText;